import React, { useState } from "react";
import { ChevronDown, ChevronRight, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import NotificationDetails from "./NotificationDetails";
import NotificationList from "./NotificationList";

const NotificationCenter = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-0 bg-custom-bg-purple w-full flex-1 h-full min-h-0 max-w-full">
      {/* Header with Accordion Toggle and Cancel */}
      <div className="flex items-center justify-between pr-fluid-2">
        <div
          className="pl-fluid-2 rounded-xl w-fit flex items-center gap-1 mt-fluid-2 cursor-pointer select-none"
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          <h4 className="text-fluid-lg font-semibold text-[#0c1629]">
            Notification Overview
          </h4>
          {isCollapsed ? (
            <ChevronRight className="w-[18px] h-[18px] text-[#0c1629]" />
          ) : (
            <ChevronDown className="w-[18px] h-[18px] text-[#0c1629]" />
          )}
        </div>

        {/* Cancel icon */}
        <X
          onClick={() => navigate("/dashboard/shipments")}
          className="w-[18px] h-[18px] text-[#0c1629] mt-fluid-2 cursor-pointer hover:text-red-600"
        />
      </div>

      <div className="fluid-0.5 flex flex-col flex-1 min-h-0 overflow-hidden">
        {/* Accordion Content for Notification */}
        <div
          className={`transition-all duration-300 ease-in-out overflow-hidden ${
            isCollapsed ? "max-h-0 opacity-0" : "max-h-[500px] opacity-100"
          }`}
        >
          <NotificationList />
        </div>

        {/* Notification Section */}
        <div className="flex-1 overflow-auto">
          <NotificationDetails />
        </div>
      </div>
    </div>
  );
};

export default NotificationCenter;
